<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="grid grid-cols-12">
                <div class="col-span-12 mb-4 lg:col-span-6 lg:pr-4 lg:mb-0">
                    <vx-badge color="violet" size="sm" class="px-2!">
                        Optional
                        <font-awesome-icon widthAuto :icon="faPencilSlash"></font-awesome-icon>
                    </vx-badge>
                    <h3 class="mt-2 text-xl text-slate-700 font-extrabold">Starter Template</h3>
                    <p class="text-sm">
                        Download a template to get going. Checkout out more advanced examples in our
                        <a
                            href="https://explore.voxie.com/voxiesupport/contact-imports"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="no-underline! text-sky-500"
                            >documentation</a
                        >.
                    </p>
                </div>
                <div class="col-span-12 lg:col-span-6">
                    <csv-template :downloadHref="onCorporate() ? csvUrl : groupCsvUrl">
                        <template v-slot:head>
                            <tr>
                                <th>first_name</th>
                                <th>last_name</th>
                                <th>phone</th>
                            </tr>
                        </template>

                        <tr>
                            <td>Jane</td>
                            <td>Smith</td>
                            <td>15554443333</td>
                        </tr>
                    </csv-template>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { VxExpandableCard, VxBadge } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import csvUrl from '@csv/contact_csv_upload_template_with_subscriptions.csv';
import groupCsvUrl from '@csv/contact_csv_upload_template_without_subscriptions.csv';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import CsvTemplate from '~/components/general/CsvTemplate.vue';

const { onCorporate } = useCurrentGroup();
</script>
